module.exports = __webpack_public_path__ + "static/img/logo_jbsthj.c3a9118d.png";